import { SVGProps } from "react";

export const IconFun = ({ width = 64, height = 64, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="#2BDC98"
      stroke="#3F4A61"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M28.259 53.853c.378-.618.689-1.28.92-1.984l13.174-28.388c2.63 1.933 6.022 5.356 8.19 11.06l.934-.355-.935.356c.922 2.426.148 5.287-1.36 8.047-1.49 2.725-3.57 5.121-4.856 6.481l.727.687-.727-.687c-.202.214-.406.465-.52.744a1.245 1.245 0 0 0-.089.654c.047.32.226.593.485.765.223.149.45.186.59.195a1.6 1.6 0 0 0 .394-.024c.217-.04.43-.117.615-.206 3.682-1.764 7.735-4.876 10.122-9.154 2.416-4.33 3.083-9.788.048-16.04-3.47-7.153-5.94-12.187-7.543-15.433a1044.021 1044.021 0 0 0-2.198-4.428l-.105-.21-.027-.052-.006-.013-.002-.004-.108.053.108-.054c-.175-.347-.587-.88-1.3-.863-.706.018-1.094.561-1.257.91L26.81 41.95c-1.723-1.875-4.124-3.266-6.915-3.83-6.301-1.274-12.544 2.142-13.71 7.954-1.167 5.81 3.27 11.384 9.571 12.658 4.896.99 9.707-.834 12.194-4.406.1-.09.182-.2.24-.325l.069-.148Z"
    />
  </svg>
);
